import * as React from 'react'
export const WebinarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={85} height={84} fill="none" {...props}>
    <g filter="url(#a)">
      <circle cx={42.5} cy={42} r={22} fill="#fff" />
    </g>
    <g clipPath="url(#b)">
      <path
        fill="#E12468"
        stroke="#E12468"
        d="m46.168 42.427.7-.427-.7-.427-5.657-3.454-.761-.465v8.691l.76-.464 5.658-3.454Zm-5.967-5.086.76.462v-.002l5.987 3.658v.001c.19.117.302.32.302.535a.631.631 0 0 1-.301.536h-.001L40.2 46.655a.626.626 0 0 1-.955-.53V37.87a.624.624 0 0 1 .956-.529Zm10.077-3.12a11 11 0 1 0-15.556 15.557 11 11 0 0 0 15.556-15.556Zm.354 15.91A11.5 11.5 0 1 1 34.368 33.87a11.5 11.5 0 0 1 16.264 16.263Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M30.5 30h24v24h-24z" />
      </clipPath>
      <filter
        id="a"
        width={84}
        height={84}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_10204_271035" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_10204_271035" result="shape" />
      </filter>
    </defs>
  </svg>
)
